import React, { useState } from 'react';
import { MockParameterState } from '../MockParameters';
import Switcher from '../../../../../components/ui/switcher/Switcher';

interface Props {
  mockService: MockParameterState;
  onUpdateState: (state: MockParameterState) => void;
}

const HttpKeystoreOverride = ({ mockService, onUpdateState }: Props) => {
  const [httpRunnerOverrideKeystore, setHttpRunnerOverrideKeystore] = useState(mockService.httpRunnerOverrideKeystore);
  const [httpRunnerOverrideTruststore, setRunnerOverrideTrustStore] = useState(
    mockService.httpRunnerOverrideTruststore,
  );

  return (
    <div>
      <Switcher
        className={'mb-4'}
        checked={httpRunnerOverrideKeystore}
        onChange={() => {
          setHttpRunnerOverrideKeystore(!httpRunnerOverrideKeystore);
          onUpdateState({ ...mockService, httpRunnerOverrideKeystore: !httpRunnerOverrideKeystore });
        }}
        label={'Override Server Keystore'}
        size={'md'}
      />
      <Switcher
        checked={httpRunnerOverrideTruststore}
        onChange={() => {
          setRunnerOverrideTrustStore(!httpRunnerOverrideTruststore);
          onUpdateState({ ...mockService, httpRunnerOverrideTruststore: !httpRunnerOverrideTruststore });
        }}
        label={'Override Server Truststore & Keystore'}
        size={'md'}
      />
    </div>
  );
};

export default HttpKeystoreOverride;
